import { isEmpty } from 'lodash';
import { Box, IconButton, Input, Spinner } from '@chakra-ui/react';

import { CloseIcon } from 'Asset/icon';
import { Condition, Element } from 'Component/others';
import { TextRegular, TextSemiBold } from 'UiKit/typography';
import SkeletonComponent from 'UiKit/skeleton';

import styles from './styles.module.css';

const InputComponent = ({
  label,
  placeholder,
  onChange,
  value,
  isDisabled,
  isReadOnly,
  isImmutable,
  error,
  rightButton,
  width,
  isRequired,
  register,
  type = 'text',
  margin,
  className,
  infoMessage,
  isReset,
  handleReset,
  isLoading,
  isFetching,
  'data-testid': testId,
  height = '42px',
  rightLabel,
  rightLabelPosition = 'space-between',
  isNumber = false,
}) => {
  const isError = !isEmpty(error);

  const handleInput = (inputValue) => {
    if (!isNumber) return inputValue;

    const numericValue = inputValue.replace(/[^0-9]/g, '');

    if (numericValue.startsWith('0') && numericValue.length > 1) return numericValue.replace(/^0+/, '');
    if (numericValue === '0') return '';

    return numericValue;
  };

  return (
    <Box
      margin={margin}
      className={`${className}
      ${styles['input-component__container']}
      ${isDisabled && styles['input-component__container--disabled']}
      ${isReadOnly && styles['input-component__container--readonly']}
      ${isImmutable && styles['input-component__container--immutable']}
      ${isError && styles['input-component__container--error']}`}
    >
      <Condition statement={label}>
        <Box className={styles['label__container']} justifyContent={rightLabelPosition}>
          <TextSemiBold className={styles['text__title']}>
            {label}{' '}
            <Condition statement={isRequired}>
              <span>*</span>
            </Condition>
          </TextSemiBold>
          <Condition statement={rightLabel}>
            <Box className={styles['box__right-label']}>{rightLabel}</Box>
          </Condition>
        </Box>
      </Condition>

      <Condition statement={infoMessage && !isError}>
        <TextRegular className={styles['info__text']}>{infoMessage}</TextRegular>
      </Condition>

      <Condition
        statement={!isFetching}
        fallback={
          <Box className={styles['input-skeleton__container']} width={width}>
            <SkeletonComponent width="40%" height="100%" />
          </Box>
        }
      >
        <Box position="relative">
          <Input
            height={height}
            background={isEmpty(value) ? 'var(--color-semantic-background)' : 'white'}
            type={type}
            width={width}
            focusBorderColor="transparent"
            onChange={(e) => onChange(handleInput(e.target.value))}
            className={styles['input']}
            value={value ?? ''}
            disabled={isDisabled}
            readOnly={isReadOnly || isImmutable}
            placeholder={placeholder}
            autoFocus={false}
            autoComplete="new-password"
            data-testid={testId}
            {...register}
          />

          <Condition statement={isReset}>
            <IconButton icon={<CloseIcon />} className={styles['button__reset']} variant="ghost" onClick={handleReset} />
          </Condition>

          <Condition statement={isLoading}>
            <Box className={styles['loader']}>
              <Spinner size="sm" color="var(--color-primary70)" data-testid="input-spinner" />
            </Box>
          </Condition>
          <Condition statement={rightButton}>
            <Element value={rightButton} />
          </Condition>
        </Box>
      </Condition>

      <Condition statement={isError}>
        <TextRegular className={styles['error__text']}>{error?.message}</TextRegular>
      </Condition>
    </Box>
  );
};

export default InputComponent;
